import React from 'react';
import useWidgetActionsBuilder from '../../../../hooks/generic/Actions/useWidgetActionsBuilder';
import ChrWidget from '../../../generic/PageUI/Compound/ChrWidget';
import { getCommonDateRangeWithPresetFilterValue } from '../../../generic/Utils/commonUtils';
import { getDefaultWidgetConfigs, getRemoteConfigs } from '../utils';
import MeetingSurveysWidgetBody from './body';

const MeetingSurveys = (props) => {
  const { name, url, actionsData } = props;
  const defaultWidgetConfigs = getDefaultWidgetConfigs({ ...props, ...{ className: "grid-item-span-full-width" } });
  const filterKey = 'respondedIn';
  const configBuilder = (state) => {
    return {
      remoteOptions: getRemoteConfigs(url, MeetingSurveysWidgetBody, { filters: getCommonDateRangeWithPresetFilterValue(state, filterKey, 'responded_in_date_range') })
    };
  }
  const { actions, widgetConfig, widgetUtils } = useWidgetActionsBuilder(actionsData, configBuilder);

  return (
    <ChrWidget
      widgetUtils={ widgetUtils }
      {...defaultWidgetConfigs}
      header={name}
      headerActions={actions.headerActions}
      {...widgetConfig.remoteOptions}
      footerActions={ actions.footerActions }
    />
  );
};

export default MeetingSurveys;